import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Locale } from '../../enums/i18n/locale.enum';
import { Privacy } from '../../models/sys/privacy';
import { AppStateService } from '../app-state.service';
import { ScriptLoaderService } from '../sys/script-loader.service';

@Injectable({
  providedIn: 'root',
})
export class BotChatService {
  private readonly _appState: AppStateService = inject(AppStateService);
  private readonly _scriptLoader: ScriptLoaderService =
    inject(ScriptLoaderService);

  private readonly _available$: BehaviorSubject<boolean>;
  private readonly _accepted$: BehaviorSubject<boolean>;
  private _scriptLoaded: boolean = false;

  public constructor() {
    this._available$ = new BehaviorSubject<boolean>(false);
    this._accepted$ = new BehaviorSubject<boolean>(false);
  }

  public get available$(): Observable<boolean> {
    return this._available$.asObservable();
  }

  public get accepted$(): Observable<boolean> {
    return this._accepted$.asObservable();
  }

  public bootstrap(): void {
    if (!environment.mavicBotScript) {
      return;
    }

    const allowedLocales: Locale[] = environment.mavicBotLocales ?? [];

    this._appState.locale$
      .pipe(map((locale: Locale) => allowedLocales.includes(locale)))
      .subscribe((available: boolean) => {
        this._available$.next(available);
      });

    this._appState.privacy$
      .pipe(map((privacy: Privacy | undefined) => !!privacy?.mavicBot))
      .subscribe((accepted: boolean) => {
        this._accepted$.next(accepted);
        if (accepted) {
          this.ensureScriptLoaded();
        }
      });
  }

  public ensureScriptLoaded(): void {
    if (this._scriptLoaded || !environment.mavicBotScript) {
      return;
    }

    this._scriptLoaded = true;
    this._scriptLoader.load(environment.mavicBotScript).subscribe();
  }
}
